import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../lib/AuthContext';
import orangeLogo from '../assets/orangelog.png';

const T = {
  accent:  '#dd3333',
  navy:    '#13273F',
  border:  '#e8e8e8',
  white:   '#fff',
  meta:    '#777',
  lightBg: '#f4f4f4',
};

const US_STATES = [
  'AL','AK','AZ','AR','CA','CO','CT','DE','FL','GA','HI','ID','IL','IN','IA',
  'KS','KY','LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ',
  'NM','NY','NC','ND','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT','VT',
  'VA','WA','WV','WI','WY','DC',
];

function FieldGroup({ label, required, children }) {
  return (
    <div style={{ marginBottom: '1rem' }}>
      <label style={{ display: 'block', fontSize: '0.82rem', fontWeight: '700', color: '#333', fontFamily: 'Arial, sans-serif', marginBottom: '0.3rem' }}>
        {label}{required && <span style={{ color: T.accent, marginLeft: '2px' }}>*</span>}
      </label>
      {children}
    </div>
  );
}

const inputSty = (err) => ({
  width: '100%', boxSizing: 'border-box',
  padding: '0.6rem 0.8rem',
  border: `1px solid ${err ? T.accent : '#ccc'}`,
  borderRadius: '5px', fontSize: '0.92rem',
  fontFamily: 'Arial, sans-serif', outline: 'none',
  background: '#fff',
});

function CompanyContact() {
  const navigate = useNavigate();
  const { accessToken } = useAuth();
  const userType = localStorage.getItem('userType');
  const username = localStorage.getItem('username');

  const [form, setForm] = useState({
    contactName: '', contactEmail: '', companyName: '', companyWebsite: '',
    phone: '', street: '', city: '', state: '', zip: '',
    description: '', hearAbout: '',
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [serverError, setServerError] = useState('');

  const set = (field) => (e) => {
    setForm(f => ({ ...f, [field]: e.target.value }));
    setErrors(er => ({ ...er, [field]: '' }));
  };

  const validate = () => {
    const e = {};
    if (!form.contactName.trim())  e.contactName  = 'Required';
    if (!form.contactEmail.trim()) e.contactEmail = 'Required';
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.contactEmail)) e.contactEmail = 'Enter a valid email';
    if (!form.companyName.trim())  e.companyName  = 'Required';
    return e;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length) { setErrors(errs); return; }
    setLoading(true); setServerError('');
    try {
      await axios.post('/api/contact/publisher', form);
      setDone(true);
    } catch (err) {
      setServerError(err.response?.data?.error || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const siloHref = (() => {
    if (!accessToken) return null;
    if (userType === 'company') return `/adminHUD/${encodeURIComponent(localStorage.getItem('companyName') || '')}`;
    if (userType === 'user')   return `/${username}`;
    return null;
  })();

  return (
    <div style={{ minHeight: '100vh', background: T.lightBg, fontFamily: 'Arial, sans-serif' }}>

      {/* Navbar — LP5 grid */}
      <nav style={{ background: '#111111', display: 'grid', gridTemplateColumns: '220px 1fr 300px', gridTemplateRows: '110px 36px', position: 'sticky', top: 0, zIndex: 1000, boxShadow: '0 2px 12px rgba(0,0,0,0.6)' }}>
        <div style={{ gridColumn: 1, gridRow: '1 / 3', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#F41238', cursor: 'pointer' }} onClick={() => navigate('/')}>
          <img src={orangeLogo} alt="PubSilo" style={{ height: '90%', maxWidth: '210px', objectFit: 'contain' }} />
        </div>
        <div style={{ gridColumn: 2, gridRow: 1, background: T.navy, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '4px' }}>
          <div style={{ color: '#aaa', fontSize: '12px', letterSpacing: '0.08em', textTransform: 'uppercase' }}>Join</div>
          <div style={{ color: T.white, fontSize: '28px', fontWeight: '300', letterSpacing: '0.06em', lineHeight: 1 }}>Become a Publisher</div>
        </div>
        <div style={{ gridColumn: 3, gridRow: '1 / 3', background: T.navy, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '12px' }}>
          {accessToken && siloHref ? (
            <Link to={siloHref} style={{ background: T.accent, color: T.white, textDecoration: 'none', fontSize: '13px', fontWeight: '700', padding: '9px 18px', borderRadius: '5px', whiteSpace: 'nowrap' }}>
              {userType === 'company' ? 'Admin Page' : 'My Silo'}
            </Link>
          ) : (
            <>
              <Link to="/login" style={{ color: '#ccc', textDecoration: 'none', fontSize: '13px', fontWeight: '700', padding: '8px 15px', border: '1px solid #3a3a3a', borderRadius: '5px' }}>Login</Link>
              <Link to="/signup/reader" style={{ background: T.accent, color: T.white, textDecoration: 'none', fontSize: '13px', fontWeight: '700', padding: '9px 18px', borderRadius: '5px', whiteSpace: 'nowrap' }}>Sign Up</Link>
            </>
          )}
        </div>
        <div style={{ gridColumn: 2, gridRow: 2, background: '#0d1f33' }} />
      </nav>

      {/* Body */}
      <div style={{ maxWidth: '680px', margin: '3rem auto', padding: '0 1.5rem 4rem' }}>

        {done ? (
          <div style={{ background: T.white, borderRadius: '10px', padding: '3rem', textAlign: 'center', boxShadow: '0 2px 12px rgba(0,0,0,0.07)' }}>
            <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>✅</div>
            <h2 style={{ fontSize: '1.4rem', fontWeight: '800', color: '#111', marginBottom: '0.75rem' }}>Inquiry Received!</h2>
            <p style={{ color: T.meta, fontSize: '0.95rem', lineHeight: '1.6', marginBottom: '1.5rem' }}>
              Thanks for your interest in publishing on PubSilo. Our team will review your information and reach out to <strong>{form.contactEmail}</strong> within 2–3 business days.
            </p>
            <button onClick={() => navigate('/')} style={{ background: T.accent, color: T.white, border: 'none', borderRadius: '6px', padding: '0.75rem 2rem', fontWeight: '700', fontSize: '0.95rem', cursor: 'pointer' }}>
              Back to PubSilo
            </button>
          </div>
        ) : (
          <>
            <div style={{ marginBottom: '2rem' }}>
              <h1 style={{ fontSize: '1.6rem', fontWeight: '900', color: '#111', marginBottom: '0.5rem' }}>Publisher Inquiry</h1>
              <p style={{ color: T.meta, fontSize: '0.92rem', lineHeight: '1.6' }}>
                Interested in publishing on PubSilo? Fill out the form below and our team will be in touch to walk you through the process and set up your account.
              </p>
            </div>

            <form onSubmit={handleSubmit} noValidate>

              {/* Contact info */}
              <div style={{ background: T.white, borderRadius: '10px', padding: '1.5rem', boxShadow: '0 1px 6px rgba(0,0,0,0.06)', marginBottom: '1.25rem' }}>
                <div style={{ fontSize: '11px', fontWeight: '900', textTransform: 'uppercase', letterSpacing: '0.09em', color: T.accent, borderBottom: `2px solid ${T.accent}`, paddingBottom: '6px', marginBottom: '1rem' }}>Contact Information</div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 1rem' }}>
                  <FieldGroup label="Contact Name" required>
                    <input value={form.contactName} onChange={set('contactName')} style={inputSty(errors.contactName)} placeholder="Jane Smith" />
                    {errors.contactName && <div style={{ fontSize: '0.77rem', color: T.accent, marginTop: '3px' }}>{errors.contactName}</div>}
                  </FieldGroup>
                  <FieldGroup label="Contact Email" required>
                    <input type="email" value={form.contactEmail} onChange={set('contactEmail')} style={inputSty(errors.contactEmail)} placeholder="jane@yoursite.com" />
                    {errors.contactEmail && <div style={{ fontSize: '0.77rem', color: T.accent, marginTop: '3px' }}>{errors.contactEmail}</div>}
                  </FieldGroup>
                </div>
                <FieldGroup label="Phone Number">
                  <input value={form.phone} onChange={set('phone')} style={inputSty()} placeholder="(555) 000-0000" />
                </FieldGroup>
              </div>

              {/* Company info */}
              <div style={{ background: T.white, borderRadius: '10px', padding: '1.5rem', boxShadow: '0 1px 6px rgba(0,0,0,0.06)', marginBottom: '1.25rem' }}>
                <div style={{ fontSize: '11px', fontWeight: '900', textTransform: 'uppercase', letterSpacing: '0.09em', color: T.navy, borderBottom: `2px solid ${T.navy}`, paddingBottom: '6px', marginBottom: '1rem' }}>Company Information</div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 1rem' }}>
                  <FieldGroup label="Company / Publication Name" required>
                    <input value={form.companyName} onChange={set('companyName')} style={inputSty(errors.companyName)} placeholder="The Daily Gazette" />
                    {errors.companyName && <div style={{ fontSize: '0.77rem', color: T.accent, marginTop: '3px' }}>{errors.companyName}</div>}
                  </FieldGroup>
                  <FieldGroup label="Company Website">
                    <input value={form.companyWebsite} onChange={set('companyWebsite')} style={inputSty()} placeholder="https://yourdomain.com" />
                  </FieldGroup>
                </div>
                <FieldGroup label="Brief Description of Your Publication">
                  <textarea value={form.description} onChange={set('description')} rows={3} style={{ ...inputSty(), resize: 'vertical' }} placeholder="Tell us about your publication — what topics you cover, your audience, and your content style." />
                </FieldGroup>
              </div>

              {/* Address */}
              <div style={{ background: T.white, borderRadius: '10px', padding: '1.5rem', boxShadow: '0 1px 6px rgba(0,0,0,0.06)', marginBottom: '1.25rem' }}>
                <div style={{ fontSize: '11px', fontWeight: '900', textTransform: 'uppercase', letterSpacing: '0.09em', color: '#555', borderBottom: '2px solid #ddd', paddingBottom: '6px', marginBottom: '1rem' }}>Address</div>
                <FieldGroup label="Street Address">
                  <input value={form.street} onChange={set('street')} style={inputSty()} placeholder="123 Main St" />
                </FieldGroup>
                <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', gap: '0 1rem' }}>
                  <FieldGroup label="City">
                    <input value={form.city} onChange={set('city')} style={inputSty()} placeholder="Tulsa" />
                  </FieldGroup>
                  <FieldGroup label="State">
                    <select value={form.state} onChange={set('state')} style={{ ...inputSty(), cursor: 'pointer' }}>
                      <option value="">--</option>
                      {US_STATES.map(s => <option key={s} value={s}>{s}</option>)}
                    </select>
                  </FieldGroup>
                  <FieldGroup label="ZIP Code">
                    <input value={form.zip} onChange={set('zip')} style={inputSty()} placeholder="74103" maxLength={10} />
                  </FieldGroup>
                </div>
              </div>

              {/* How did you hear */}
              <div style={{ background: T.white, borderRadius: '10px', padding: '1.5rem', boxShadow: '0 1px 6px rgba(0,0,0,0.06)', marginBottom: '1.75rem' }}>
                <FieldGroup label="How did you hear about PubSilo?">
                  <select value={form.hearAbout} onChange={set('hearAbout')} style={{ ...inputSty(), cursor: 'pointer' }}>
                    <option value="">Select one</option>
                    <option value="Search engine">Search engine</option>
                    <option value="Social media">Social media</option>
                    <option value="Referral from another publisher">Referral from another publisher</option>
                    <option value="Referral from a reader">Referral from a reader</option>
                    <option value="News article or press">News article or press</option>
                    <option value="PubSilo outreach">PubSilo outreach</option>
                    <option value="Other">Other</option>
                  </select>
                </FieldGroup>
              </div>

              {serverError && (
                <div style={{ background: '#fdecea', border: '1px solid #f5c6cb', borderRadius: '6px', padding: '0.75rem 1rem', marginBottom: '1rem', color: '#721c24', fontSize: '0.88rem' }}>
                  {serverError}
                </div>
              )}

              <button
                type="submit"
                disabled={loading}
                style={{ width: '100%', padding: '0.9rem', background: loading ? '#999' : T.navy, color: T.white, border: 'none', borderRadius: '8px', fontSize: '1rem', fontWeight: '700', cursor: loading ? 'not-allowed' : 'pointer', letterSpacing: '0.03em' }}
              >
                {loading ? 'Sending…' : 'Submit Inquiry'}
              </button>

              <p style={{ textAlign: 'center', color: '#aaa', fontSize: '0.78rem', marginTop: '0.75rem' }}>
                Already have an account? <Link to="/login" style={{ color: T.accent }}>Log in here</Link>
              </p>
            </form>
          </>
        )}
      </div>
    </div>
  );
}

export default CompanyContact;
